// Version : 0.0.1
// Author : AGALYA
// LastEdit : SHIYAM
// Last ADD : changed the file and folder name with hyphen
// MODFIED DATE : 05-08-2025

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** ***************** ADD PURPOSE OF LOAN DETAILS START *********************** */
export const purposeofLoanDetailsAdd = (addData: any) => {
	const data = {
		AddPurposeOfLoanDetailsToken: addData,
	};
	const url = `${API_URL}addPurposeOfLoanDetails`;
	return makeApiCall(url, data);
};
/** ***************** ADD PURPOSE OF LOAN DETAILS END *********************** */

/** ***************** UPDATE PURPOSE OF LOAN DETAILS START *********************** */
export const purposeofLoanDetailsUpdate = (updateData: any) => {
	const data = {
		UpdatePurposeOfLoanDetailsToken: updateData,
	};
	const url = `${API_URL}updatePurposeOfLoanDetails`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE PURPOSE OF LOAN DETAILS END *********************** */

/** ***************** GET PURPOSE OF LOAN DETAILS START *********************** */
export const purposeofLoanListGet = (listData: any) => {
	const data = {
		GetPurposeOfLoanListToken: listData,
	};
	const url = `${API_URL}getPurposeOfLoanList`;
	return makeApiCall(url, data);
};
/** ***************** GET PURPOSE OF LOAN DETAILS END *********************** */

/** ***************** FETCH PURPOSE OF LOAN DETAILS START *********************** */
export const purposeofLoanDetailsFetch = (fetchData: any) => {
	const data = {
		FetchPurposeOfLoanDetailsToken: fetchData,
	};
	const url = `${API_URL}fetchPurposeOfLoanDetails`;
	return makeApiCall(url, data);
};
/** ***************** FETCH PURPOSE OF LOAN DETAILS END *********************** */

/** ***************** DELETE PURPOSE OF LOAN DETAILS START *********************** */
export const purposeofLoanDetailsDelete = (deleteData: any) => {
	const data = {
		DeletePurposeOfLoanDetailsToken: deleteData,
	};
	const url = `${API_URL}deletePurposeOfLoanDetails`;
	return makeApiCall(url, data);
};
/** ***************** DELETE PURPOSE OF LOAN DETAILS END *********************** */

/** ***************** UPDATE PURPOSE OF LOAN PUBLISH STATUS START *********************** */
export const purposeOfLoanIsPublishUpdate = (updateData: any) => {
	const data = {
		UpdatePurposeOfLoanPublishStatusToken: updateData,
	};
	const url = `${API_URL}updatePurposeOfLoanPublishStatusToken`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE PURPOSE OF LOAN PUBLISH STATUS END *********************** */
